import { Component } from 'react';
import PropTypes from 'prop-types';
import { PANES, ACTIONS } from '../../constants/checkoutConstants';

// components
import Action from './CheckoutAction';
import CheckoutEditAction from './actions/CheckoutEditAction';

class CheckoutEditActionLink extends Component {
    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);
    }
    onClick(event) {
        const { serviceId, onClick } = this.props;
        event.preventDefault();
        event.stopPropagation();
        onClick(serviceId);
    }
    render() {
        const { type, serviceId } = this.props;
        return (
            <Action
                type={type}
                serviceId={serviceId}
                actionType={ACTIONS.ACTION_EDIT}
                action={<CheckoutEditAction />}
                onClick={this.onClick}
            />
        );
    }
}

CheckoutEditActionLink.propTypes = {
    type: PropTypes.oneOf([PANES.PANE_SHIPPING]).isRequired,
    serviceId: PropTypes.any.isRequired,
    onClick: PropTypes.func.isRequired,
};

export default CheckoutEditActionLink;
